const evalEnvVar = (
  envVarName, // environment variable is fetched from process.env[envVarName]
  stringToMatchOrEvalFn,
  {
    // stringToMatchOrEvalFn:
    //    is of type: string or fn (envVarDeserializer(process.env[envVarName])) => any
    //    if string, eval strict equality match on env var = envVarDeserializer(process.env[envVarName])
    //    else if fn, eval evalFn on env var.
    allowList, // array of allowed values, once passed to envVarDeserializer
    // throws error if envVarDeserializer(env var) not in allowList
    envVarDeserializer = (x) => x, // e.g. to convert a serialized env var string to JS bool, etc.
  },
) => {
  const val = envVarDeserializer(process.env[envVarName]);
  if (typeof allowList === 'object' && allowList.length > 0 && !allowList.includes(val)) {
    throw new Error(
      `Expected process.env.${envVarName} to be from allowed list ${JSON.stringify(
        allowList,
      )} but got: ${val}`,
    );
  }
  if (typeof stringToMatchOrEvalFn === 'string') {
    return val === stringToMatchOrEvalFn;
  }
  if (typeof stringToMatchOrEvalFn === 'function') {
    return stringToMatchOrEvalFn(val);
  }
  throw new Error(
    `Expected stringToMatchOrEvalFn to be string or function. ` +
      `Got ${JSON.stringify(stringToMatchOrEvalFn)} when evaluating process.env.${envVarName}`,
  );
};

const evalBooleanEnvVar = (serializedBoolEnvVarName, evalFn) =>
  evalEnvVar(
    serializedBoolEnvVarName,
    evalFn,
    ['true', 'false'],
    // by default, a null/undefined env var (e.g. in development) should eval to false
    (val) => (val === 'true' ? 'true' : 'false'),
  );

const isBooleanTrueEvalFn = (val) => val === 'true';

const evalBooleanEnvVarIsTrue = (serializedBoolEnvVarName) =>
  evalBooleanEnvVar(serializedBoolEnvVarName, isBooleanTrueEvalFn);

const UNSET = Symbol('UNSET');
const evalStringOneOf = (serializedStringEnvVarName, oneOfValues, defaultValue = UNSET) => {
  // with evalStringOneOf, defaultValue is set when the variable doesn't exist in the env
  // if defaultValue is used, we need to add it to the allowList
  const allowList =
    defaultValue !== UNSET && !oneOfValues.includes(defaultValue)
      ? [defaultValue, ...oneOfValues]
      : oneOfValues;

  if (!allowList.length) {
    throw new Error(`evalStringOneOf: allowList is empty`);
  }

  return evalEnvVar(serializedStringEnvVarName, (val) => val, {
    allowList,
    envVarDeserializer: (val) => (val === undefined && defaultValue !== UNSET ? defaultValue : val),
  });
};

module.exports = {
  evalBooleanEnvVarIsTrue,
  evalStringOneOf,
};
